import Loading from "react-loading";
import DataFrame from "../../components/DataFrame/DataFrame";
import Button from "heroic-ui-library/dist/components/Button";
import { AnimatePresence, motion } from "framer-motion";
import Title from "../../components/Title/Title";
import gristerImg from "../../assets/grister.png";

import CountUp from "react-countup";
import { useEffect, useState } from "react";
import { apiClient } from "../../api/api-client";
import { useNavigate, useParams } from "react-router";
import { ChildrenInfo, InfoData, RequestRewardResponse } from "../../lib/type";
import ChildrenInfoComp from "./ChildrenInfo";
import { delete_cookie, get_cookie_value, set_cookie } from "../../lib";

export default function TapGrister() {
  const [screen, setScreen] = useState<"second" | "third" | "loading">(
    "loading"
  );
  const [selectedKidResponse, setSelectedKidResponse] = useState<
    RequestRewardResponse | undefined
  >(undefined);
  const [children, setChildren] = useState<ChildrenInfo | undefined>(undefined);
  const [selectedKid, setSelectedKid] = useState<number>(-1);
  const [getClickingGritSecond, setClickingGritSecond] = useState<number>(0);
  const [info, setInfo] = useState<InfoData>({} as InfoData);
  const [showInstallAppBtn, setShowInstallAppBtn] = useState<boolean>(false);
  const { parent_code } = useParams();

  const nav = useNavigate();

  useEffect(() => {
    setScreen("loading");

    apiClient.getParentInformation(parent_code + "").then(async (resp) => {
      if (resp.code === 200) {
        setInfo(resp);
        if (resp.data.child_info.length > 0) {
          if (!resp.data.get_reward_today) setClickingGritSecond(Date.now());

          if (resp.data.get_reward_today) {
            const cookie_value = get_cookie_value("redirect");

            if (cookie_value && cookie_value == "true") {
              delete_cookie("redirect");
              return (window.location.href =
                "https://parent.heroicgameday.com/dashboard/?parent_code=" +
                parent_code);
            }
          }

          setScreen(resp.data.get_reward_today ? "third" : "second");
          setChildren({ data: resp.data.child_info });
          setSelectedKid(0);

          setSelectedKidResponse({
            child_ha_token: +resp.data.child_info[0].attendance_token,
            streak_login: +resp.data.child_info[0].daily_attendance_streak,
          });
        } else nav("/connect");
      } else nav("/connect");
    });

    setShowInstallAppBtn(sessionStorage.getItem("show_install_app") === "1");
  }, [nav, parent_code]);

  const parentGetRewardForChild = async () => {
    const resp = await apiClient.parentGetRewardForChild(
      info.data.parent_code,
      (Date.now() - getClickingGritSecond) / 1000
    );

    setSelectedKidResponse(resp);
    setScreen("third");

    apiClient.getParentInformation(parent_code + "").then(async (resp) => {
      console.log("resp", resp);
      if (resp.code === 200 && resp.data.parent_code) {
        setInfo(resp);
        setChildren({ data: resp.data.child_info });

        const index = 0;
        if (resp.data.child_info[index]) {
          setSelectedKid(index);
          setSelectedKidResponse({
            child_ha_token: parseInt(
              resp.data.child_info[index].attendance_token
            ),
            streak_login: parseInt(
              resp.data.child_info[index].daily_attendance_streak
            ),
          });
        }
      }
    });
  };

  const nag_to_email = () => nav("/email");
  const nag_to_login = () => nav("/connect");

  const install_app = () => {
    window.top && window.top.dispatchEvent(new CustomEvent("installApp"));
  };

  const select_child = (index: number) => {
    const data = children?.data[index];

    if (data) {
      setSelectedKid(index);
      setSelectedKidResponse({
        child_ha_token: parseInt(data.attendance_token),
        streak_login: parseInt(data.daily_attendance_streak),
      });
    }
  };

  const onDeleteChild = (index: number) => {
    const itemToDelete = children?.data[index];

    const filteredKids = children!.data.filter(
      (k) => k.child_id != itemToDelete?.child_id
    );

    if (filteredKids.length === 0) {
      nav("/connect");
    } else {
      const newSelectedItem = filteredKids[0];
      setChildren({ data: filteredKids });
      setSelectedKid(0);
      setSelectedKidResponse({
        child_ha_token: +newSelectedItem.daily_attendance_streak,
        streak_login: +newSelectedItem.daily_attendance_streak,
      });
    }

    apiClient.removeChild(itemToDelete!.child_id, parent_code!);
  };

  const onRemoveAll = () => {
    apiClient.removeAll(parent_code!);
    nav("/connect");
  };

  const goToParentDashboard = () => {
    if (info.data.if_login == "0") {
      set_cookie("redirect", "true");
      return nav("/", { state: { hideCodeBtn: true } });
    }

    window.location.href =
      "https://parent.heroicgameday.com/dashboard/?parent_code=" + parent_code;
  };

  return (
    <AnimatePresence>
      {screen === "loading" && (
        <div className="flex items-center justify-center h-full">
          <Loading type="spin" color="#002356" />
        </div>
      )}
      {screen === "second" && (
        <motion.div
          key={"second_screen"}
          className="flex flex-col items-center justify-center h-full relative -top-16"
          exit={{ opacity: 0 }}
        >
          <motion.div
            key={"top_main_heading"}
            initial={"closed"}
            animate={"open"}
            exit={"closed"}
            variants={{
              open: { opacity: 1, y: "0%" },
              closed: { opacity: 0, y: "-100%" },
            }}
            transition={{ duration: 1 }}
            className="relative mx-auto flex items-center justify-center"
          >
            <Title text="Tap on the Gritster to double your child's Heroic Attendance Tokens today and Watch Your Child Succeed!" />
          </motion.div>
          <div
            onClick={parentGetRewardForChild}
            className="relative w-full h-[60%] flex items-center"
          >
            <motion.div
              animate={{ x: ["-0vw", "85vw", "-0vw"] }}
              transition={{
                duration: 15,
                repeat: Infinity,
                repeatType: "loop",
                ease: "linear",
              }}
              key={"gristerImg"}
              className="relative flex flex-col items-center justify-center cursor-pointer select-none"
            >
              <motion.img src={gristerImg} className=" pt-5  w-48" />
              <div className="attendance-token">
                2x Heroic Attendance Tokens
              </div>
            </motion.div>
          </div>
        </motion.div>
      )}
      {screen == "third" && (
        <motion.div
          variants={{
            open: { opacity: 1, y: "0%" },
            closed: { opacity: 0, y: "-100%" },
          }}
          initial={"closed"}
          animate={"open"}
          exit={"closed"}
          className="w-full h-full absolute top-0 flex flex-col justify-center items-start"
          key={"third_screen"}
        >
          <div className="flex flex-row space-x-8 absolute top-3 right-3 z-50">
            {info.data.if_login == "1" && (
              <Button
                className="btn"
                btnType="orange"
                label="Connect another child"
                onClick={nag_to_login}
              />
            )}

            <Button
              className="btn"
              btnType="orange"
              label="Send link to mail box"
              onClick={nag_to_email}
            />

            {showInstallAppBtn && (
              <Button
                className="btn"
                btnType="orange"
                label="Install App"
                onClick={install_app}
              />
            )}
          </div>

          <Title
            className="text-[2.4rem]"
            text="Nice Work - your child will receive 2x tokens today! You are an awesome parent - thanks for helping your child learn the critical life-skills of success!"
          />
          <div className="frames-containers">
            <DataFrame className="!w-[18rem]">
              <div className="text-2xl text-blue-950 text-primary font-acme px-2 text-center mt-2 leading">
                Your Child's Total Heroic Attendance Tokens
              </div>
              <CountUp
                className="count-down "
                end={selectedKidResponse?.child_ha_token ?? 1}
              />
            </DataFrame>
            <DataFrame className="!w-[18rem]">
              <div className="text-2xl text-blue-950 text-primary font-acme px-2 text-center mt-2 leading">
                Your Child's current daily attendence GritStreak for this month
              </div>
              <span className="count-down text-center w-full">
                <CountUp
                  className="count-down"
                  end={selectedKidResponse?.streak_login ?? 1}
                />{" "}
                days
              </span>
            </DataFrame>
            <DataFrame className="!w-[18rem] show-only-desktop ">
              <div className="flex flex-row justify-between items-center">
                <h3 className="list-item text-white text-xl font-acme">
                  Your Child's List
                </h3>
                <div className="font-acme cursor-pointer" onClick={onRemoveAll}>
                  Remove All
                </div>
              </div>
              {children?.data?.length && (
                <ChildrenInfoComp
                  data={children.data}
                  selectedChild={selectedKid}
                  select_child={select_child}
                  onDeleteChild={onDeleteChild}
                />
              )}
            </DataFrame>
          </div>
          <div className="flex flex-col items-center mt-6 w-full show-only-desktop">
            <div className="heading-inverse w-[70%] mb-8">
              If you want to see the other great skills your child is learning
            </div>
            <div className="flex flex-row space-x-6">
              <Button
                className="btn play-now"
                btnType={+info.data.if_login == 0 ? "blue" : "green"}
                label={
                  +info.data.if_login == 0
                    ? "Access Full Parent Dashboard"
                    : "Parent Dashboard"
                }
                onClick={goToParentDashboard}
              />
            </div>
          </div>
          <div className="show-only-mobile w-full">
            <div className="flex flex-row w-full items-center space-x-6">
              <div>
                <DataFrame className="!w-[18rem] ">
                  <div className="flex flex-row justify-between items-center">
                    <h3 className="list-item text-white text-xl font-acme">
                      Your Child's List
                    </h3>
                    <div
                      className="font-acme cursor-pointer"
                      onClick={onRemoveAll}
                    >
                      Remove All
                    </div>
                  </div>
                  {children?.data?.length && (
                    <ChildrenInfoComp
                      data={children.data}
                      selectedChild={selectedKid}
                      select_child={(number) => setSelectedKid(number)}
                      onDeleteChild={onDeleteChild}
                    />
                  )}
                </DataFrame>
              </div>
              <div>
                <div className="heading-inverse mb-8 text-left">
                  If you want to see the other great skills your child is
                  learning
                </div>
                <div className="flex flex-row space-x-6">
                  <Button
                    className="btn play-now"
                    btnType="green"
                    label="Parent Dashboard"
                    onClick={goToParentDashboard}
                  />
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
